export default "__VITE_ASSET__BlxO$nXX__"